// select options
export const basicCurves = [
  { name: 'Linear', value: 'linear', labelId: 'LINEAR' },
  { name: 'Curved', value: 'monotoneX', labelId: 'CURVED' },
  { name: 'Step', value: 'step', labelId: 'STEP' },
];

export const colors = [
  'nivo',
  'category10',
  'accent',
  'dark2',
  'paired',
  'pastel1',
  'pastel2',
  'set1',
  'set2',
  'set3',
  'brown_blueGreen',
  'purpleRed_green',
  'pink_yellowGreen',
  'purple_orange',
  'red_blue',
  'red_grey',
  'red_yellow_blue',
  'red_yellow_green',
  'spectral',
  'blues',
  'greens',
  'greys',
  'oranges',
  'purples',
  'reds',
  'blue_green',
  'blue_purple',
  'green_blue',
  'orange_red',
  'purple_blue_green',
  'purple_blue',
  'purple_red',
  'red_purple',
  'yellow_green_blue',
  'yellow_green',
  'yellow_orange_brown',
  'yellow_orange_red',
];

// Lines Group
export const lineGroup = [
  {
    name: 'curve',
    labelId: 'SHAPE',
    type: 'select',
    default: 'linear',
    options: basicCurves,
  },
  {
    name: 'lineWidth',
    labelId: 'LINE_WIDTH',
    type: 'slider',
    default: 1,
    options: {
      min: 1,
      max: 10,
      step: 1,
    },
  },
  {
    name: 'areaOpacity',
    labelId: 'AREA_OPACITY',
    type: 'slider',
    default: 0.1,
    options: {
      min: 0,
      max: 1,
      step: 0.05,
    },
  },
  {
    name: 'dotSize',
    labelId: 'DOT_SIZE',
    type: 'slider',
    default: 6,
    group: 'lines',
    options: {
      min: 0,
      max: 12,
      step: 1,
    },
  },
  {
    name: 'enableDotLabel',
    labelId: 'ENABLE_DOT_LABEL',
    type: 'switch',
    default: false,
  },
  {
    name: 'yScale.stacked',
    labelId: 'STACK_LINES',
    type: 'switch',
    default: false,
  },
];

// Axis/Grid Group
export const axisGroup = [
  {
    name: 'enableAxisLabelY',
    labelId: 'ENABLE_AXIS_LABEL_Y',
    type: 'switch',
    default: false,
  },
  {
    name: 'enableGridX',
    labelId: 'ENABLE_GRID_X',
    type: 'switch',
    default: true,
  },
  {
    name: 'enableGridY',
    labelId: 'ENABLE_GRID_Y',
    type: 'switch',
    default: true,
  },
  {
    name: 'enableLegend',
    labelId: 'ENABLE_LEGEND',
    type: 'switch',
    default: true,
  },
  {
    name: 'legendWidth',
    labelId: 'LEGEND_WIDTH',
    type: 'slider',
    default: 100,
    options: {
      min: 50,
      max: 200,
      step: 5,
    },
  },
];

// Extra Group
export const extraGroup = [
  {
    name: 'dotBorderWidth',
    labelId: 'DOT_BORDER_WIDTH',
    type: 'slider',
    default: 1,
    options: {
      min: 0,
      max: 10,
      step: 1,
    },
  },
  {
    name: 'colors',
    labelId: 'COLORS',
    type: 'select',
    default: 'set1',
    options: colors,
  },
  {
    name: 'yDensity',
    labelId: 'TICK_LEFT_DENSITY',
    type: 'slider',
    default: 30,
    options: {
      min: 1,
      max: 100,
      step: 1,
    },
  },
  {
    name: 'xDensity',
    labelId: 'TICK_BOTTOM_DENSITY',
    type: 'slider',
    default: 40,
    options: {
      min: 1,
      max: 100,
      step: 1,
    },
  }, /* {
  name: 'axisBottom.tickRotation',
  labelId: 'TICK_ROTATION',
  type: 'select',
  default: -45,
  options: tickRotations,
}, {
  name: 'axisBottom.tickFormat.step',
  labelId: 'TICK_STEP',
  type: 'slider',
  default: 1,
  options: {
    min: 1,
    max: 10,
    step: 1,
  },
},{
  name: 'axisBottom.tickFormat.type',
  labelId: 'TICK_TYPE',
  type: 'select',
  default: 'hour',
  options: tickTypes,
},{
  name: 'theme.axis.fontSize',
  labelId: 'LABEL_FONT_SIZE',
  type: 'slider',
  default: 7,
  options: {
    min: 6,
    max: 20,
    step: 0.5,
  },
}, */
  {
    name: 'margin.top',
    labelId: 'MARGIN_TOP',
    type: 'slider',
    renderRequired: true,
    default: 5,
    options: {
      min: 0,
      max: 200,
      step: 5,
    },
  },
  {
    name: 'margin.right',
    labelId: 'MARGIN_RIGHT',
    type: 'slider',
    renderRequired: true,
    default: 5,
    options: {
      min: 0,
      max: 200,
      step: 5,
    },
  },
  {
    name: 'margin.bottom',
    labelId: 'MARGIN_BOTTOM',
    type: 'slider',
    renderRequired: true,
    default: 35,
    options: {
      min: 0,
      max: 200,
      step: 5,
    },
  },
  {
    name: 'margin.left',
    labelId: 'MARGIN_LEFT',
    type: 'slider',
    renderRequired: true,
    default: 40,
    options: {
      min: 0,
      max: 200,
      step: 5,
    },
  },
];

// Hidden properties to be applied automatically
export const hiddenGroup = [
  {
    name: 'dotBorderColor',
    type: 'hidden',
    default: 'inherit:darker(1.2)',
  },
  {
    name: 'animated',
    type: 'hidden',
    default: true,
  },
  {
    name: 'enableArea',
    type: 'hidden',
    default: true,
  },
  {
    name: 'yScale.type',
    type: 'hidden',
    default: 'linear',
  },
  {
    name: 'axisBottom.legendPosition',
    type: 'hidden',
    default: 'middle',
  },
  {
    name: 'axisBottom.legendOffset',
    type: 'hidden',
    default: 44,
  },
  {
    name: 'axisLeft.legendPosition',
    type: 'hidden',
    default: 'middle',
  },
  {
    name: 'axisLeft.legendOffset',
    type: 'hidden',
    default: -32,
  },
  {
    name: 'axisLeft.legend',
    type: 'hidden',
    default: 'minutes',
  },
  {
    name: 'margin.top',
    type: 'hidden',
    default: 5,
  },
  {
    name: 'margin.right',
    type: 'hidden',
    default: 5,
  },
  {
    name: 'margin.bottom',
    type: 'hidden',
    default: 35,
  },
  {
    name: 'margin.left',
    type: 'hidden',
    default: 40,
  },
];

export const controlsList = [
  ...lineGroup,
  ...axisGroup,
  ...extraGroup,
  ...hiddenGroup,
];
